// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCard-modulebody__mz7eq";
var _2 = "BirdviewChartCard-modulechart__NS6xx";
var _3 = "BirdviewChartCard-modulecontrols__MM4ma";
export { _1 as "body", _2 as "chart", _3 as "controls" }
